import axios, { AxiosResponse } from 'axios'; //npm install axios --save //npm install --save es6-promise For IE
import { Constant } from '@/helpers/constant';
import { Rest, RestHeader } from '@/helpers/rest';
import { EmployerAdmin } from '@/models/employerAdmin';
import { Skill } from '@/models/skill';
import { AssessmentByAdmin } from '@/models/assessmentByAdmin';
import router from '@/router';

class AdminService {

  axios;

  constructor() {
    this.axios = axios.create({});
  }

  public createEmployerAdmin(employerAdmin: EmployerAdmin): Promise<AxiosResponse<any>> {
    employerAdmin.provider = Constant.ADMIN_PROVIDER;

    return this.axios.post(Constant.SERVER_URL + 'api/admin/createEmployerAdmin', employerAdmin,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {

        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public checkEmailIDExistsWithAuth(email: String): Promise<AxiosResponse<any>> {
    let data = {
      "email":email,
      "provider":Constant.ADMIN_PROVIDER
    }
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getAdminByEmailWithAuth', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {

        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public checkUserExistsInAdmin(email: String): Promise<AxiosResponse<any>> {
    let data = {
      "username":email,
      "provider":Constant.ADMIN_PROVIDER,
      "domain":"UPSKILL"
    }
    return this.axios.post(Constant.SERVER_URL + 'api/admin/checkUsernameExists', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {

        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
       
      });
  }

  public loginEmployerAdmin(credentials): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'oauth/token', credentials,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public loginLDAPAdmin(credentials): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/admin/login-admin', credentials,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITHOUT_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllEmployers(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/allemployers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllEmployersByStatus(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/getAllEmployersByStatus', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllJobseekers(data:any): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/jobseekerAdmin/allJobseekers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllJobseekersAppealList(data:any): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/admin/showAllAppeal', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }


  public getCurrentAdminUser(data): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/admin/getCurrentEmployerAdmin', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Invalid Credentials!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getAllEmployerAdmin(): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.ADMIN_PROVIDER
    }

    return this.axios.post(Constant.SERVER_URL + 'api/admin/employers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public viewProfile(id:number,provider): Promise<AxiosResponse<any>> {
    let url = "api/jobseekerAdmin";
    let data = {
      "provider": provider
    }
    if(provider == Constant.ADMIN_PROVIDER){
      let url = "api/jobseekerAdmin";
      let data = {
        "provider": provider
      }
    }else{
      let url = "api/jobseekerEmployer";
      let data = {
        "provider": provider
      }
    }
    return this.axios.post(Constant.SERVER_URL + url+'/showJobseeker/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public viewProfileApprove(id:any,provider): Promise<AxiosResponse<any>> {
    let data = {
      "provider": provider
    }
    return this.axios.post(Constant.SERVER_URL +'api/admin/showAppeal/'+id, data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getCandidatesBySearch(data): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/search-jobseeker', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getEmployerBySearch(data): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/searchEmployers', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }
  public getEmployerJobseekerStatistics(data): Promise<AxiosResponse<any>> {

    return this.axios.post(Constant.SERVER_URL + 'api/admin/getEmployerJobseekerStatistics', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getSkillsByAdminId(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getSkillsByAdminId', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getAssessmentListBySkillId(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getAssessmentListBySkillId', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public createSkill(skill: Skill): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/createSkill', skill,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public updateSkill(skill: Skill, skillId): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/updateSkill/'+skillId, skill,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public deleteSkillBySkillId(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/deleteSkillBySkillId', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }
  
  public createAssessment(assessmentByAdmin: AssessmentByAdmin): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/createAssessment', assessmentByAdmin,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getAssessmentDetailByAssessmentByAdminId(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getAssessmentDetailByAssessmentByAdminId', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public updateAssessment(assessmentByAdmin: AssessmentByAdmin, assessmentByAdminId): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/updateAssessment/'+ assessmentByAdminId, assessmentByAdmin,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getEmployerJobseekerRegisterationReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getEmployerJobseekerRegisterationReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getEmployerJobseekerRegisterationDefaultReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getEmployerJobseekerRegisterationDefaultReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getPostJobVsAppliedJobStateWiseReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getPostJobVsAppliedJobStateWiseReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getPostJobVsAppliedJobIndustryWiseReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getPostJobVsAppliedJobIndustryWiseReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getPostJobVsAppliedJobCategoryWiseReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getPostJobVsAppliedJobCategoryWiseReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getPostJobVsAppliedJobEmploymentTypeWiseReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getPostJobVsAppliedJobEmploymentTypeWiseReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getPostJobVsAppliedJobPositionWiseReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getPostJobVsAppliedJobPositionLevelWiseReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getPostJobVsAppliedJobsVacanciesReport(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getPostJobVsAppliedJobsVacanciesReport', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public updateAssessmentDisplayStatus(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/updateAssessmentDisplayStatus', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }
  
  public getUpskillPostedJobsReportByType(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getUpskillPostedJobsReportByType', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }


  public getUpskillEmployerReportByType(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getUpskillEmployerReportByType', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }


  public getUpskillJobseekerReportByType(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/getUpskillJobseekerReportByType', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }
  public sendBulkEmail(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/sendbulkmail', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }
  public rejectAd(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/employerAdmin/rejectAdvertisement', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public getAllEmployerAdmins(): Promise<AxiosResponse<any>> {
    let data = {
      provider: Constant.EMPLOYER_PROVIDER
    }

    return this.axios.post(Constant.SERVER_URL + 'api/adminEmployer/allEmployerAdmin', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {

        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
        // Manage the state of the application if the request
        // has failed
      });
  }

  public getKeySkills(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/AllKeySkill', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public showKeySkill(data:any): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/showKeySkill/'+data.id,data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          // localStorage.clear();
          // router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public createKeySkill(keyskill): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/createKeySkill', keyskill,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public updateKeySkill(keyskill,id): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/admin/updateKeySkill/'+id, keyskill,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRD Corp Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
          alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        else {
          return err;
        }
      });
  }

  public updateJobseekerAppealStatus(data): Promise<AxiosResponse<any>> {
 
    
    return this.axios.post(Constant.SERVER_URL + 'api/admin/updateAppeal', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
  
}
export default new AdminService();
